import { get } from 'lodash'

export default class Cache {
  element_type;
  id;

  constructor(element_type, id = null) {
    this.element_type = element_type;
    this.id = id;

    this.onSaveComplete();
  }

  get(value) {
    const key = this.storageKey()
    const contents = JSON.parse(localStorage.getItem(key))
    if (contents && value) {
      return contents[value]
    } else {
      return contents
    }
  }

  save(data) {
    const key = this.storageKey()
    localStorage.setItem(key, JSON.stringify(data))
  }

  delete() {
    const key = this.storageKey()
    localStorage.removeItem(key)
  }

  clearAndReset() {
    this.delete()
  }

  onSaveComplete(elements) {
    $('#page-editor').on('save-page-complete', this.delete.bind(this))
  }

  storageKey() {
    return this.element_type + (this.id || "")
  }
}
